<app-z-dialog
  [title]="data.title | transloco"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <section class="d-flex flex-column align-items-center">
    <mat-icon [style.color]="data.iconColor">
      {{ data.icon }}
    </mat-icon>
    <h2 mat-dialog-title>{{ data.title | transloco }}</h2>
    <p>{{ data.message | transloco }}</p>
  </section>
</ng-template>
<ng-template #buttonsTemplate>
  <button
    *ngFor="let button of data.buttons"
    mat-raised-button
    [color]="button.color"
    [class]="button.class"
    [matTooltip]="button.label | transloco"
    (click)="confirm(button.value)"
  >
    <mat-icon class="s-me-1">{{ button.icon || "brightness_low" }}</mat-icon>
    {{ button.label | transloco }}
  </button>
</ng-template>
